// TollRates.js

import React, { useEffect } from "react";

function TollRates() {
  useEffect(() => {
    if (window.gtag && window.consented)
      window.gtag("event", "page_view", { page: "toll_rates" });
  }, []);

  return (
    <section className="utility canada-theme us-theme">
      <h2>Tunnel Toll Rates</h2>
      <p>Current toll rates for the Detroit-Windsor Tunnel (as of 2026).</p>

      <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
        {/* Windsor to Detroit */}
        <div style={{ flex: "1", minWidth: "300px" }}>
          <h3>Windsor → Detroit</h3>
          <table className="toll-table">
            <thead>
              <tr>
                <th>Vehicle Type</th>
                <th>Toll Rate</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>NEXPRESS (Cashless)</td>
                <td>$5.90 CAD / $4.70 USD</td>
              </tr>
              <tr>
                <td>Regular (Cash)</td>
                <td>$8.25 CAD</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Detroit to Windsor */}
        <div style={{ flex: "1", minWidth: "300px" }}>
          <h3>Detroit → Windsor</h3>
          <table className="toll-table">
            <thead>
              <tr>
                <th>Vehicle Type</th>
                <th>Toll Rate</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>NEXPRESS (Cashless)</td>
                <td>$9.25 CAD / $6.75 USD</td>
              </tr>
              <tr>
                <td>Regular (Cash)</td>
                <td>$9.00 CAD</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}

export default TollRates;
